import { render } from "./add-prompt-to-pack.vue?vue&type=template&id=285640a2&lang=pug"
import script from "./add-prompt-to-pack.vue?vue&type=script&lang=js"
export * from "./add-prompt-to-pack.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__